<template>
  <div id="app">
    <router-view/>
  </div>
</template>

<script>
export default {
  name: 'App'
}
</script>

<style>
  body {
    font-family: "Microsoft YaHei", "微软雅黑", "宋体", "Arial";
    background: #ffffff;
  }

  body, div, dl, dt, dd, ul, ol, li, h1, h2, h3, h4, h5, h6, pre, code,
  form, fieldset, legend, input, button, textarea, p, blockquote, th, td {
    margin: 0;
    padding: 0;
  }

  ol, ul {
    list-style: none;
  }

  address, caption, cite, code, dfn, em, strong, th, var, optgroup {
    font-style: normal;
  }

  input, button, textarea, select, optgroup, option {
    font-family: inherit;
    font-size: inherit;
    font-style: inherit;
    font-weight: inherit;
  }

  fieldset, img, a img, :link img, :visited img {
    border: 0;
  }

  a {
    text-decoration: none;
  }

  a:hover {
    text-decoration: none;
  }

  :focus {
    outline: 0;
  }

  table {
    border-collapse: collapse;
    border-spacing: 0;
  }

  caption, th {
    text-align: left;
  }

  sup, sub {
    font-size: 100%;
    vertical-align: baseline;
  }

  blockquote, q {
    quotes: none;
  }

  blockquote:before, blockquote:after, q:before, q:after {
    content: '';
    content: none;
  }

  img {
    display: block;
    max-width: 100%;
    margin: 0 auto;
  }

  .page {
    width: 100%;
    margin: 0 auto 0.8rem;
  }

  .content {
    margin-top: 0.3rem;
  }

  .sp_underline {
    text-decoration: underline;
    font-weight: bold;
  }

  .content p {
    text-indent: 32px;
    font-size: 0.3rem;
    font-family: "Microsoft YaHei", "微软雅黑", "宋体", "Arial";
  }

  .content p, .content h2 {
    margin: 0.15rem 0.25rem;
    line-height: 0.42rem;
    color: #666666;
    word-break:break-all;
  }

  .link {
    color: #003366;
  }

  .content h2 {
    font-size: 0.32rem;
  }

  .show{
    display: block;
  }

  ul{
    font-size: 0.32rem;
    margin: 0.15rem 0.25rem 0.15rem 0.7rem;
  }

  li{
    line-height: 0.42rem;
    word-break:break-all;
    list-style: disc;
    color: #666666;
    font-size: 0.3rem;
    font-family: "Microsoft YaHei", "微软雅黑", "宋体", "Arial";

  }

  .law_english .content h2 {
    color: #000000;
    font-size: 0.32rem;
    font-weight: bold;
  }

  .law_chinese .content h2 {
    color: #000000;
    font-size: 0.32rem;
    font-weight: bold;
  }

  .law_chinese .sp_underline{
    color: #000000;
  }

  .law_chinese .link{
    color: #000000;
    font-size: 0.3rem;
  }
</style>



// WEBPACK FOOTER //
// src/App.vue